import { Box, Typography } from '@mui/material';
import NameCell from '../Table/NameCell';
import i18n from '../../i18n';
import { Role } from '../../redux/coachGroup/coachGroupSlice';

export interface IMemberRow {
  id: string;
  avatar: string;
  lastActivity: string;
  name: string;
  firstName: string;
  lastName: string;
  profilePic: string;
  email: string;
  profilePicture: string;
  isActive: boolean;
  role: Role;
  totalClients?: number;
  totalSessions?: number;
  tp?: string;
}

interface IRenderCellParams {
  row: IMemberRow;
  value: string | boolean;
}

export interface IColumn {
  field: string;
  headerName: string;
  hide?: boolean;
  width?: number;
  disableColumnMenu?: boolean;
  sortable?: boolean;
  flex?: number;
  renderCell?: (_params: IRenderCellParams) => React.ReactNode;
  renderHeader?: (_params: IRenderCellParams) => React.ReactNode;
}

const membersColumns: IColumn[] = [
  { field: 'id', headerName: 'ID', hide: true },
  {
    field: 'name',
    headerName: i18n.t('teamMembersTable.name'),
    width: 500,
    disableColumnMenu: true,
    sortable: false,
    flex: 4,
    renderCell: (params: IRenderCellParams) => (
      <NameCell
        avatar={params.row.profilePic}
        firstName={params.row.firstName}
        lastName={params.row.lastName}
      />
    ),
    renderHeader: () => (
      <Box display="flex">
        <Typography variant="meta" color="primary">
          {i18n.t('teamMembersTable.name')}
        </Typography>
      </Box>
    ),
  },
  {
    field: 'role',
    headerName: i18n.t('teamMembersTable.role'),
    width: 500,
    disableColumnMenu: true,
    sortable: false,
    flex: 4,
    renderCell: (params: IRenderCellParams) => (
      <Typography variant="bodyRegular" color="primary">
        {params.row.role}
      </Typography>
    ),
    renderHeader: () => (
      <Box display="flex">
        <Typography variant="meta" color="primary">
          {i18n.t('teamMembersTable.role')}
        </Typography>
      </Box>
    ),
  },
  {
    field: 'totalSessions',
    headerName: i18n.t('teamMembersTable.totalSessions'),
    width: 500,
    disableColumnMenu: true,
    sortable: false,
    flex: 4,
    renderCell: (params: IRenderCellParams) => (
      <Typography variant="bodyRegular" color="primary">
        {params.row.totalSessions}
      </Typography>
    ),
    renderHeader: () => (
      <Box display="flex">
        <Typography variant="meta" color="primary">
          {i18n.t('teamMembersTable.totalSessions')}
        </Typography>
      </Box>
    ),
  },
  {
    field: 'totalClients',
    headerName: i18n.t('teamMembersTable.totalClients'),
    width: 500,
    disableColumnMenu: true,
    sortable: false,
    flex: 4,
    renderCell: (params: IRenderCellParams) => (
      <Typography variant="bodyRegular" color="primary">
        {params.row.totalClients}
      </Typography>
    ),
    renderHeader: () => (
      <Box display="flex">
        <Typography variant="meta" color="primary">
          {i18n.t('teamMembersTable.totalClients')}
        </Typography>
      </Box>
    ),
  },
];

const activeFields: string[] = ['name', 'role'];
const archivedFields: string[] = ['name', 'role'];

export const activeTeamMembersColumns: IColumn[] = membersColumns.filter((column) =>
  activeFields.includes(column.field)
);

export const archivedTeamMembersColumns: IColumn[] = membersColumns.filter((column) =>
  archivedFields.includes(column.field)
);
